import { I18n } from '@calendly/i18n';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { LocationIcon } from 'components/core/location_icon';
import { LocationIconColor } from '../../location_icon_color';
import { useStateValue } from '../state_provider';
const containerCss = "c2b8leg";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const nameCss = "n1nbjhaa";
const Name = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(nameCss, props.className)} />;
});
const oldIconWrapperCss = "o1ncjpzg";
const OldIconWrapper = forwardRef((props, ref) => <LocationIconColor ref={ref} {...props} className={classNames(oldIconWrapperCss, props.className)} />);
const newIconWrapperCss = "ngdo41x";
const NewIconWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(newIconWrapperCss, props.className)} />;
});
const INFO_ATTRIBUTE_FOR_KIND = {
  custom: 'location',
  physical: 'location',
  inbound_call: 'phone_number'
};
const IconWrapper = ({
  useNewWrapper,
  children,
  ...props
}) => {
  if (useNewWrapper) {
    return <NewIconWrapper {...props}>
        {children}
      </NewIconWrapper>;
  }
  return <OldIconWrapper {...props}>
      {children}
    </OldIconWrapper>;
};
const infoForLocation = location => {
  const defaultInfo = I18n.t(`publisher.event_types.location.${location.kind}.label`);
  return location[INFO_ATTRIBUTE_FOR_KIND[location.kind]] || defaultInfo;
};
export const PrimaryInfo = ({
  location
}) => {
  const state = useStateValue();
  const useNewWrapper = state?.useNewDropdown;
  return <Container>
      <IconWrapper useNewWrapper={useNewWrapper} kind={location.kind}>
        <LocationIcon kind={location.kind} />
      </IconWrapper>
      <Name>{infoForLocation(location)}</Name>
    </Container>;
};

require("./primary_info.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./primary_info.js");